import React, { useState } from 'react';
import SiteHeader from 'views/layouts/SiteHeader/SiteHeader';
import SiteFooter from 'views/layouts/SiteFooter/SiteFooter';
import SiteAside from 'views/layouts/SiteAside/SiteAside';
import '../../../index.scss';
import 'views/pages/App/App.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import SiteContent from 'views/layouts/SiteContent/SiteContent';
import UserContainer from 'containers/UserContainer';
import { getClaims, hasFullAccess } from 'util/userAccessValidation';

const App = ({ authContext, client }) => {
  const [isActive, setNav] = useState('');
  const loggedIn = authContext.isAuthenticated() ? 'logged-in' : 'logged-out';

  console.log(`Starting App.`);

  return (
    <React.Fragment>
      <React.Fragment>
        <UserContainer>
          {({ data }) => {
            let isAdminUserAuth = data ? hasFullAccess(data.UserInfo) : false;
            let claims = data ? getClaims(data.UserInfo) : [];

            console.log({ description: `Inside UserContainer.`, isAdminUserAuth, claims });

            return (
              <div className={`site-wrap ${loggedIn} layout-aside nav-${isActive} bg-page`}>
                <ToastContainer />
                <SiteHeader isActive={isActive} setNav={setNav} />
                <SiteAside
                  auth={authContext}
                  location={location}
                  isActive={isActive}
                  isAdminUserAuth={isAdminUserAuth}
                />
                <SiteContent isAdminUserAuth={isAdminUserAuth} claims={claims} client={client} />
                <SiteFooter />
              </div>
            );
          }}
        </UserContainer>
      </React.Fragment>
      {/* )} */}
    </React.Fragment>
  );
};
export default App;
